import { FormattedErrors, PayElement } from 'type';
import { createAsyncAction } from 'lib/store-utils';
import { PayElementsCreateRequest, PayElementsUpdateRequest } from 'lib/Api';
import { DeletePayload, DeleteSuccessPayload } from './types';

export const BOX_PAY_ELEMENTS_PAY_ELEMENT_CREATE = createAsyncAction<PayElementsCreateRequest, PayElement, FormattedErrors>('Pay Elements / Pay element / create');
export const BOX_PAY_ELEMENTS_PAY_ELEMENT_UPDATE = createAsyncAction<PayElementsUpdateRequest, PayElement, FormattedErrors>('Pay Elements / Pay element / update');
export const BOX_PAY_ELEMENTS_PAY_ELEMENT_DELETE = createAsyncAction<DeletePayload, DeleteSuccessPayload, FormattedErrors>('Pay Elements / Pay element / delete');
